const INITIAL_STATE = [];

export default function performanceYears(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case 'data-load_FULFILLED': {
      if (payload && payload.key === 'performanceYears') {
        return [
          ...payload.response.data,
        ];
      }

      return state;
    }

    default:
      return state;
  }
}
